import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-loading-01',
  imports: [],
  templateUrl: './loading-01.html',
  styleUrl: './loading-01.scss',
})
export class Loading01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
